import { h } from 'preact'
import { Message } from '../../../../../lib/intl/Message'
import { InfoHeading } from '../shared'
import { Geografi } from '../../../../domain'

type Props = {
  geografi: Geografi
}

export function KretsOgBydelInfo({ geografi }: Props) {
  if (geografi.navn.nb.toLowerCase().indexOf('uoppgitt') === -1) {
    return (
      <section>
        <InfoHeading id="info-bydelkrets-forhandsstemmer-tittel" />
        <Message id="info-bydelkrets-forhandsstemmer-beskrivelse" />
      </section>
    )
  }

  return null
}
